// @ts-nocheck
import React, { lazy, useEffect } from 'react';
import { Dialog, DialogSuspense, FormattedMessage as T } from '@/components';
import { useDispatch } from 'react-redux';
import { resetEditItem } from '@/store/items/editItem';
import withDialogRedux from '@/components/DialogReduxConnect';
import { compose } from '@/utils';

const EditItemFormDialogContent = lazy(() =>
  import('./EditItemFormDialogContent'),
);

// Edit item dialog for editing item, variants, charges and decoration
function EditItemDialog({
  dialogName,
  payload = { id: null, entryId: null, presentationId: null },
  isOpen,
}) {
  const dispatch = useDispatch();

  // Reset Redux state when dialog closes so next open starts clean
  useEffect(() => {
    if (!isOpen) {
      dispatch(resetEditItem());
    }
  }, [isOpen]);

  return (
    <Dialog
      name={dialogName}
      className={'dialog--edit-item-form'}
      isOpen={isOpen}
      autoFocus={true}
      canEscapeKeyClose={true}
      style={{ width: '90vw', height: '90vh', maxWidth: 'none', maxHeight: '90vh', margin: 0, overflow: 'auto',paddingBottom: 0 }}
    >
      <DialogSuspense>
        {isOpen && (
          <EditItemFormDialogContent
            key={`${payload.presentationId ?? ''}-${payload.entryId ?? payload.id}`}
            dialogName={dialogName}
            itemId={payload.id}
            entryId={payload.entryId}
            presentationId={payload.presentationId}
          />
        )}
      </DialogSuspense>
    </Dialog>
  );
}

export default compose(withDialogRedux())(EditItemDialog);
